import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showConfirmReportIncidentPopup } from '~/actions';
import { RadioOption, Text } from '~/commonComponents';
import { ConfirmPopupContent } from '~/components/shared/ConfirmPopupContent';
import WarningIcon from '~/images/warning-icon.svg';
import { Colors } from '~/themes/colors';
import { incidentTypes } from '../utils/incidentPopupUtil';
import { NumberUtils } from '~/utils/NumberUtils';

export const ConfirmationSelectIncident = ({ onClose }) => {
  const dispatch = useDispatch();
  const [incidentType, setIncidentType] = useState(null);

  return (
    <ConfirmPopupContent
      Icon={() => <img src={WarningIcon} style={{ marginBottom: 20 }} alt="warning_icon" data-cy="incident-warning-icon" />}
      title="Report An Incident"
      description={
        <div data-cy="select-incident-type-content">
          <Text textAlign="center" data-cy="incident-prompt-text">What type of incident would you like to report?</Text>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
              marginTop: 20,
              marginBottom: 20,
            }}
            data-cy="incident-type-options"
          >
            <RadioOption
              textStyle={{ color: Colors.neutral_500 }}
              onClick={() => setIncidentType(incidentTypes.noShow)}
              text="No-Show"
              checked={incidentType === incidentTypes.noShow}
              dataCy="incident-type-no-show"
            />
            <RadioOption
              textStyle={{ color: Colors.neutral_500 }}
              onClick={() => setIncidentType(incidentTypes.walkedOut)}
              text="Walked-Out"
              checked={incidentType === incidentTypes.walkedOut}
              dataCy="incident-type-walked-out"
            />
          </div>
          <Text textAlign="center" data-cy="incident-support-text">
            If the incident doesn&apos;t fall into these two categories, please call or text our
            Customer Support at {NumberUtils.getCSPhone().formattedSimplified}, and they will be able to assist you.
          </Text>
        </div>
      }
      leftButtonAction={onClose}
      leftButtonText="Go Back"
      leftButtonDataCy="incident-go-back-button"
      rightButtonAction={() => {
        dispatch(showConfirmReportIncidentPopup({ incidentType }));
      }}
      rightButtonDisabled={!incidentType}
      rightButtonText="Continue"
      rightButtonDataCy="incident-continue-button"
      data-cy="select-incident-modal"
    />
  );
};
